
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { Home } from "lucide-react";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { SocialSignIn } from "@/components/auth/SocialSignIn";

const SignUp = () => {
  const { toast } = useToast();

  return (
    <div className="min-h-screen flex items-center justify-center bg-flux-black p-4">
      {/* Home Button */}
      <Button
        asChild
        variant="ghost"
        className="absolute top-4 left-4 text-flux-cyan hover:text-flux-cyan/80 hover:bg-flux-cyan/10"
      >
        <Link to="/">
          <Home className="w-5 h-5" />
        </Link>
      </Button>

      <div className="w-full max-w-md space-y-8 animate-fade-in">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">Sign up</h2>
        </div>

        <div className="text-center text-sm">
          <p className="text-gray-400">
            Already have an account?{" "}
            <Link to="/signin" className="text-flux-cyan hover:text-flux-cyan/80 underline">
              Sign in
            </Link>
          </p>
        </div>

        <SignUpForm />

        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t border-gray-700" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-flux-black px-2 text-gray-400">Or continue with</span>
          </div>
        </div>

        <div>
          <SocialSignIn provider="google" className="w-full" />
        </div>

        <div className="text-center text-sm">
          <p className="text-gray-400">
            By signing up, you agree to our{" "}
            <Link to="/terms" className="text-flux-cyan hover:text-flux-cyan/80 underline">
              Terms of Service
            </Link>{" "}
            and{" "}
            <Link to="/privacy" className="text-flux-cyan hover:text-flux-cyan/80 underline">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
